import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";
import { onRouteChange } from "@/lib/posthog";

export function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
  // PostHog pageviews fire on history change by themselves; this only applies the per-route
  // policy (replay on/off). Pathname only: a ?tab= change must not restart replay.
  // A layout effect, not a passive one: it runs before the browser delivers the new page's DOM
  // mutations to the recorder, so a public -> admin navigation does not record the admin render.
  useLayoutEffect(() => {
    onRouteChange(location.pathname);
  }, [location.pathname]);
  return null;
}
